<template>
    <nav-tabs :exact="false" :tabs="[
        { label: 'Motivos de recusa', route: 'reasons' },
        { label: 'Termos jurídicos', route: 'legal-terms' },
    ]" />
    <router-view></router-view>
</template>

<script>
import NavTabs from "../../components/layouts/NavTabs.vue";
export default {
    components: { NavTabs },

    mounted() {

    }
}
</script>
